module.exports = __webpack_public_path__ + "media/images/gift-thanks-modal-bg-candy@2x-ca903482961f583a37b2b197b6a2cf99.png";